import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Badge, Form, InputGroup, Offcanvas, Nav, Tab, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import TabNuevoRNC from './TabNuevoRNC';
import TabGeneral from './TabGeneral';
import TabEditar from './TabEditar';
import TabFolios from './TabFolios';
import TabActividad from './TabActividad';
import TabAsignarPlan from './TabAsignarPlan';
import ModalAdministrarPlanes from './ModalAdministrarPlanes';

const PlanesFacturacionRepublicaDominicana = () => {
    const { token } = useToken();
    const { showSuccessToast, showErrorToast } = useToast();

    const [RNCs, setRNCs] = useState([]);
    const [filteredRNCs, setFilteredRNCs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [filterUsage, setFilterUsage] = useState('all');
    const [cargando, setCargando] = useState(false);
    
    // Estados para paginación
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const [showDetails, setShowDetails] = useState(false);
    const [idRNCSeleccionado, setIdRNCSeleccionado] = useState(null);
    const [rncSeleccionado, setRncSeleccionado] = useState(null);
    const [activeTab, setActiveTab] = useState('general');
    const [guardando, setGuardando] = useState(false);
    
    // Estado para modal de administración de planes
    const [showModalPlanes, setShowModalPlanes] = useState(false);

    // Datos de ejemplo mejorados
    const datosEjemplo = [
        {
            idRepublicaDominicanaFacturacionExistencias: 1,
            vNombre: 'INVERSIONES TECNOLÓGICAS DEL CARIBE SRL',
            vRNC: '130256789',
            vDireccionFiscal: 'CALLE PRINCIPAL NO. 123, SECTOR LOS PRADOS, SANTO DOMINGO, DISTRITO NACIONAL',
            vTelefono: '809-555-1234',
            vEmail: 'facturacion@itcaribe.do',
            vTipoContribuyente: 'PERSONA_JURIDICA',
            vActividadEconomica: 'DESARROLLO DE SOFTWARE Y CONSULTORÍA TECNOLÓGICA',
            vUsuario: 'ITCARIBE2024',
            vPassword: 'A7X9K2LP',
            dExistencia: 2500,
            dFechaExpiracion: '2024-12-31',
            bIsActive: true,
            planActual: 'Plan Mes 20US',
            foliosPlan: 200,
            foliosUsados: 1750,
            ultimaFactura: '2024-01-15',
            correoNotificacion: 'facturacion@itcaribe.do',
            idClienteAkasia: 1001,
            nombreLicenciatario: 'Carlos Alberto Martínez',
            licencias: ['12354', '23562', '45825']
        },
        {
            idRepublicaDominicanaFacturacionExistencias: 2,
            vNombre: 'DISTRIBUIDORA COMERCIAL QUISQUEYA SA',
            vRNC: '101987654',
            vDireccionFiscal: 'AVENIDA INDEPENDENCIA NO. 456, PLAZA COMERCIAL QUISQUEYA, SANTIAGO DE LOS CABALLEROS',
            vTelefono: '809-555-5678',
            vEmail: 'admin@disquisqueya.com.do',
            vTipoContribuyente: 'PERSONA_JURIDICA',
            vActividadEconomica: 'COMERCIO AL POR MAYOR DE PRODUCTOS ALIMENTICIOS',
            vUsuario: 'DISQUISQ2024',
            vPassword: 'B3M8N5QW',
            dExistencia: 5000,
            dFechaExpiracion: '2024-11-30',
            bIsActive: true,
            planActual: 'Plan Mes 30US',
            foliosPlan: 500,
            foliosUsados: 3200,
            ultimaFactura: '2024-01-14',
            correoNotificacion: 'admin@disquisqueya.com.do',
            idClienteAkasia: 1253,
            nombreLicenciatario: 'Juan de Dios López',
            licencias: ['11223', '44556', '77889', '99001', '22334']
        },
        {
            idRepublicaDominicanaFacturacionExistencias: 3,
            vNombre: 'SERVICIOS PROFESIONALES INTEGRADOS EIRL',
            vRNC: '402567891',
            vDireccionFiscal: 'CALLE DUARTE NO. 789, EDIFICIO PROFESIONAL, LA VEGA',
            vTelefono: '809-555-9012',
            vEmail: 'contabilidad@servpro.do',
            vTipoContribuyente: 'REGIMEN_SIMPLIFICADO',
            vActividadEconomica: 'SERVICIOS DE CONTABILIDAD Y AUDITORÍA',
            vUsuario: 'SERVPRO2024',
            vPassword: 'C9P4R7TY',
            dExistencia: 1000,
            dFechaExpiracion: '2024-10-15',
            bIsActive: true,
            planActual: 'Plan Mes 10US',
            foliosPlan: 100,
            foliosUsados: 450,
            ultimaFactura: '2024-01-13',
            correoNotificacion: 'contabilidad@servpro.do',
            idClienteAkasia: 1567,
            nombreLicenciatario: 'María Elena Rodríguez',
            licencias: ['33445', '55667']
        },
        {
            idRepublicaDominicanaFacturacionExistencias: 4,
            vNombre: 'IMPORTADORA Y EXPORTADORA HISPANIOLA SA',
            vRNC: '131445678',
            vDireccionFiscal: 'ZONA FRANCA INDUSTRIAL, PARQUE INDUSTRIAL LAS AMÉRICAS, SAN PEDRO DE MACORÍS',
            vTelefono: '809-555-3456',
            vEmail: 'finanzas@imexhispaniola.do',
            vTipoContribuyente: 'GRAN_CONTRIBUYENTE',
            vActividadEconomica: 'IMPORTACIÓN Y EXPORTACIÓN DE PRODUCTOS INDUSTRIALES',
            vUsuario: 'IMEXHISP2024',
            vPassword: 'D2L6W9XZ',
            dExistencia: 500,
            dFechaExpiracion: '2024-09-30',
            bIsActive: false,
            planActual: 'Plan Mes 10US',
            foliosPlan: 100,
            foliosUsados: 498,
            ultimaFactura: '2023-12-28',
            correoNotificacion: 'finanzas@imexhispaniola.do',
            idClienteAkasia: 2145,
            nombreLicenciatario: 'Pedro Antonio Fernández',
            licencias: ['66778']
        },
        {
            idRepublicaDominicanaFacturacionExistencias: 5,
            vNombre: 'CONSULTORES ASOCIADOS DEL ESTE SRL',
            vRNC: '501234567',
            vDireccionFiscal: 'AVENIDA ESPAÑA NO. 321, TORRE EMPRESARIAL DEL ESTE, PISO 8, LA ROMANA',
            vTelefono: '809-555-7890',
            vEmail: 'info@consultoreseste.do',
            vTipoContribuyente: 'PERSONA_JURIDICA',
            vActividadEconomica: 'CONSULTORÍA DE GESTIÓN EMPRESARIAL',
            vUsuario: 'CONSESTE2024',
            vPassword: 'E8K3M1VB',
            dExistencia: 3000,
            dFechaExpiracion: '2025-03-31',
            bIsActive: true,
            planActual: 'Plan Mes 20US',
            foliosPlan: 200,
            foliosUsados: 1100,
            ultimaFactura: '2024-01-15',
            correoNotificacion: 'info@consultoreseste.do',
            idClienteAkasia: 3421,
            nombreLicenciatario: 'Ana Patricia Gómez',
            licencias: ['88990', '11234', '55678', '99012']
        },
        {
            idRepublicaDominicanaFacturacionExistencias: 6,
            vNombre: 'FARMACIAS Y SUMINISTROS MÉDICOS LA SALUD SA',
            vRNC: '131678945',
            vDireccionFiscal: 'CALLE SÁNCHEZ NO. 567, CENTRO MÉDICO LA SALUD, SAN CRISTÓBAL',
            vTelefono: '809-555-2468',
            vEmail: 'facturacion@farmlasalud.com.do',
            vTipoContribuyente: 'PERSONA_JURIDICA',
            vActividadEconomica: 'COMERCIO AL POR MENOR DE PRODUCTOS FARMACÉUTICOS',
            vUsuario: 'FARMLASALUD',
            vPassword: 'F5N9T4GH',
            dExistencia: 8000,
            dFechaExpiracion: '2025-06-30',
            bIsActive: true,
            planActual: 'Plan Mes 30US',
            foliosPlan: 500,
            foliosUsados: 5600,
            ultimaFactura: '2024-01-15',
            correoNotificacion: 'facturacion@farmlasalud.com.do',
            idClienteAkasia: 4567,
            nombreLicenciatario: 'Roberto Manuel Sánchez',
            licencias: ['22345', '44567', '66789', '88901', '10111', '21314', '31415', '41516']
        }
    ];

    const ObtenerCatalogoRNCs = () => {
        setCargando(true);
        
        fetch('/api/FacturaRepublicaDominicana/ObtenerCatalogoRNCs', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        console.error('Error del servidor:', text);
                        throw new Error(`Error ${response.status}: ${response.statusText}`);
                    });
                }
                
                // Verificar si la respuesta es JSON
                const contentType = response.headers.get('content-type');
                if (!contentType || !contentType.includes('application/json')) {
                    return response.text().then(text => {
                        console.error('Respuesta no es JSON:', text);
                        throw new Error('El servidor no devolvió JSON válido');
                    });
                }
                
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.iResponseType === 1) {
                    const datos = JSON.parse(responseJson.detalles);
                    
                    // Mapear y procesar los datos del backend
                    const datosProcessados = datos.map(rnc => {
                        // Parsear licencias si viene como string JSON
                        let licenciasArray = [];
                        if (rnc.licencias) {
                            try {
                                if (typeof rnc.licencias === 'string') {
                                    licenciasArray = JSON.parse(rnc.licencias);
                                } else if (Array.isArray(rnc.licencias)) {
                                    licenciasArray = rnc.licencias;
                                }
                            } catch (e) {
                                console.error('Error al parsear licencias:', e);
                                licenciasArray = [];
                            }
                        }
                        
                        return {
                            ...rnc,
                            licencias: licenciasArray,
                            foliosUsados: rnc.foliosUsados || 0,
                            // Mapear los nombres de campos del backend a los del frontend
                            planActual: rnc.vPlanDesc || 'Sin plan asignado',
                            foliosPlan: rnc.iFolios || 0,
                            dFechaInicioPlan: rnc.dFechaInicio,
                            dFechaFinPlan: rnc.dFechaFin
                        };
                    });
                    
                    setRNCs(datosProcessados);
                    setFilteredRNCs(datosProcessados);
                } else {
                    showErrorToast(responseJson.vMessage || 'Error al obtener RNCs');
                    // Si no hay datos, usar datos de ejemplo
                    console.log('Usando datos de ejemplo debido a error en API');
                    setRNCs(datosEjemplo);
                    setFilteredRNCs(datosEjemplo);
                }
                setCargando(false);
            })
            .catch(error => {
                console.error('Error en ObtenerCatalogoRNCs:', error);
                showErrorToast(`Error: ${error.message}. Mostrando datos de ejemplo.`);
                // En caso de error, usar datos de ejemplo
                setRNCs(datosEjemplo);
                setFilteredRNCs(datosEjemplo);
                setCargando(false);
            });
    };

  
    const GuardarRNC = async (values) => {
        setGuardando(true);

        try {
            const response = await fetch("/api/FacturaRepublicaDominicana/GuardarRNC", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(values)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    showSuccessToast('RNC actualizado exitosamente');
                    setActiveTab('general');
                    ObtenerCatalogoRNCs();
                    
                    // Actualizar el RNC seleccionado
                    const rncActualizado = { ...rncSeleccionado, ...values };
                    setRncSeleccionado(rncActualizado);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast('Error al guardar');
            }
        } catch (error) {
            console.error('Error:', error);
            showErrorToast('Error al guardar cambios');
        } finally {
            setGuardando(false);
        }
    };

    const ObtenerCadenaRandom = () => {
        let caracteres = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let cadena = "";
        for (let i = 0; i < 8; i++) {
            cadena += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        }
        return cadena;
    };

    useEffect(() => {
        ObtenerCatalogoRNCs();
    }, []);

    useEffect(() => {
        let filtered = RNCs;

        // Filtrar por término de búsqueda
        if (searchTerm) {
            filtered = filtered.filter(rnc => 
                rnc.vNombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
                rnc.vRNC.includes(searchTerm) ||
                rnc.vUsuario.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filtrar por estado
        if (filterStatus !== 'all') {
            filtered = filtered.filter(rnc => 
                filterStatus === 'active' ? rnc.bIsActive : !rnc.bIsActive
            );
        }

        // Filtrar por porcentaje de uso
        if (filterUsage !== 'all') {
            filtered = filtered.filter(rnc => {
                const porcentaje = parseFloat(calcularPorcentajeUso(rnc));
                const statusColor = getStatusColor(porcentaje);
                return statusColor === filterUsage;
            });
        }

        setFilteredRNCs(filtered);
        // Resetear a la primera página cuando cambian los filtros
        setCurrentPage(1);
    }, [searchTerm, filterStatus, filterUsage, RNCs]);

    const handleNuevoRNC = () => {
        setShowDetails(true);
        setActiveTab('nuevo');
        setRncSeleccionado(null);
        setIdRNCSeleccionado(null);
    };

    const handleEditarRNC = (rnc) => {
        setRncSeleccionado(rnc);
        setIdRNCSeleccionado(rnc.idRepublicaDominicanaFacturacionExistencias);
        setShowDetails(true);
        setActiveTab('editar');
        
    };

    const handleAsignarFolio = (rnc) => {
        setRncSeleccionado(rnc);
        setIdRNCSeleccionado(rnc.idRepublicaDominicanaFacturacionExistencias);
        setShowDetails(true);
        setActiveTab('asignar');
    };

    const handleViewDetails = (rnc) => {
        setRncSeleccionado(rnc);
        setIdRNCSeleccionado(rnc.idRepublicaDominicanaFacturacionExistencias);
        setShowDetails(true);
        setActiveTab('general');
    };

    const handleCloseDetails = () => {
        setShowDetails(false);
        setRncSeleccionado(null);
        setIdRNCSeleccionado(null);
        setActiveTab('general');
    };

    const handleSuccessNuevoRNC = () => {
        showSuccessToast('RNC creado exitosamente');
        ObtenerCatalogoRNCs();
        handleCloseDetails();
    };

    const handleSuccessAsignarFolio = () => {
        showSuccessToast('Plan asignado exitosamente');
        ObtenerCatalogoRNCs();
        setActiveTab('general');
    };

    const handleCancelarEdicion = () => {
        setActiveTab('general');
    };

    const handleCancelarNuevo = () => {
        setShowDetails(false);
        setActiveTab('general');
    };

    const calcularPorcentajeUso = (rnc) => {
        const foliosUsados = rnc.foliosUsados || 0;
        const existencia = rnc.dExistencia || 0;
        
        if (existencia === 0) return '0.0';
        
        return ((foliosUsados / existencia) * 100).toFixed(1);
    };

    const getStatusColor = (porcentaje) => {
        if (porcentaje < 50) return 'success';
        if (porcentaje < 80) return 'warning';
        return 'danger';
    };

    const verificarEstadoPlan = (fechaFin) => {
        if (!fechaFin) return { estado: 'Sin plan', color: 'secondary', icono: 'times-circle' };
        
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        const fechaFinPlan = new Date(fechaFin);
        fechaFinPlan.setHours(0, 0, 0, 0);
        
        if (fechaFinPlan < hoy) {
            return { estado: 'Vencido', color: 'danger', icono: 'exclamation-triangle' };
        } else {
            return { estado: 'Vigente', color: 'success', icono: 'check-circle' };
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '-';
        try {
            return new Date(fecha).toLocaleDateString('es-DO', { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric' 
            });
        } catch (e) {
            return '-';
        }
    };

    const estadisticas = {
        total: RNCs.length,
        activos: RNCs.filter(r => r.bIsActive).length,
        inactivos: RNCs.filter(r => !r.bIsActive).length,
        totalFolios: RNCs.reduce((sum, r) => sum + (parseInt(r.dExistencia) || 0), 0),
        foliosUsados: RNCs.reduce((sum, r) => sum + (parseInt(r.foliosUsados) || 0), 0),
        totalVendido: 1000
    };

    // Calcular datos de paginación
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredRNCs.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredRNCs.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Generar números de página para mostrar
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 5;
        
        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
                pageNumbers.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = totalPages - 3; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            } else {
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
                pageNumbers.push(totalPages);
            }
        }
        
        return pageNumbers;
    };

    return (
        <>
            {/* Header Moderno */}
            <div className="mb-4">
                <Row className="align-items-center">
                    <Col>
                        <div className="d-flex align-items-center">
                            <div className="icon-circle bg-soft-primary text-primary me-3" style={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>
                                <img src="/img/bandera-dominican-republic-48.png" />
                            </div>
                            <div>
                                <h2 className="mb-0 fw-bold">Facturación República Dominicana</h2>
                                <p className="text-muted mb-0">
                                    <FontAwesomeIcon icon="flag" className="me-2" />
                                    Sistema de Comprobantes Fiscales Electrónicos (CFE)
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col xs="auto">
                        <div className="d-flex gap-2">
                            <Button 
                                variant="outline-secondary" 
                                className="shadow-sm"
                                onClick={() => setShowModalPlanes(true)}
                                title="Administrar Planes"
                            >
                                <FontAwesomeIcon icon="cog" />
                            </Button>
                            <Button 
                                variant="primary" 
                                className="shadow-sm"
                                onClick={handleNuevoRNC}
                            >
                                <FontAwesomeIcon icon="plus" className="me-2" />
                                Nuevo RNC
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Estadísticas Cards */}
            <Row className="g-3 mb-4">
                <Col xs={6} sm={6} md={4} lg={2}>
                    <Card className="border-0 shadow-sm h-100 hover-shadow stat-card stat-card-primary">
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-soft-primary text-primary me-2" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}>
                                    <FontAwesomeIcon icon="building" />
                                </div>
                                <div>
                                    <h6 className="text-muted mb-0 text-uppercase" style={{ fontSize: '0.65rem', fontWeight: '600' }}>RNCs</h6>
                                    <h4 className="mb-0 fw-bold" style={{ fontSize: '1.5rem' }}>{estadisticas.total}</h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={6} sm={6} md={4} lg={2}>
                    <Card className="border-0 shadow-sm h-100 hover-shadow stat-card stat-card-success">
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-soft-success text-success me-2" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}>
                                    <FontAwesomeIcon icon="dollar-sign" />
                                </div>
                                <div>
                                    <h6 className="text-muted mb-0 text-uppercase" style={{ fontSize: '0.65rem', fontWeight: '600' }}>Vendido</h6>
                                    <h4 className="mb-0 fw-bold text-success" style={{ fontSize: '1.25rem' }}>${estadisticas.totalVendido.toLocaleString()}</h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={6} sm={6} md={4} lg={2}>
                    <Card className="border-0 shadow-sm h-100 hover-shadow stat-card stat-card-info">
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-soft-info text-info me-2" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}>
                                    <FontAwesomeIcon icon="receipt" />
                                </div>
                                <div>
                                    <h6 className="text-muted mb-0 text-uppercase" style={{ fontSize: '0.65rem', fontWeight: '600' }}>Folios</h6>
                                    <h4 className="mb-0 fw-bold" style={{ fontSize: '1.25rem' }}>{estadisticas.totalFolios.toLocaleString()}</h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={6} sm={6} md={4} lg={2}>
                    <Card className="border-0 shadow-sm h-100 hover-shadow stat-card stat-card-warning">
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-soft-warning text-warning me-2" style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}>
                                    <FontAwesomeIcon icon="chart-line" />
                                </div>
                                <div>
                                    <h6 className="text-muted mb-0 text-uppercase" style={{ fontSize: '0.65rem', fontWeight: '600' }}>Usados</h6>
                                    <h4 className="mb-0 fw-bold" style={{ fontSize: '1.25rem' }}>{estadisticas.foliosUsados.toLocaleString()}</h4>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Barra de búsqueda y filtros */}
            <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                    <Row className="align-items-center g-3">
                        <Col xs={12} md={6} lg={4}>
                            <InputGroup>
                                <InputGroup.Text className="bg-light border-end-0">
                                    <FontAwesomeIcon icon="search" className="text-muted" />
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar por nombre, RNC o usuario..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="border-start-0 ps-0"
                                />
                            </InputGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <Form.Select 
                                value={filterStatus} 
                                onChange={(e) => setFilterStatus(e.target.value)}
                                className="shadow-sm"
                            >
                                <option value="all">Todos los estados</option>
                                <option value="active">Solo activos</option>
                                <option value="inactive">Solo inactivos</option>
                            </Form.Select>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <Form.Select 
                                value={filterUsage} 
                                onChange={(e) => setFilterUsage(e.target.value)}
                                className="shadow-sm"
                            >
                                <option value="all">Todos los niveles de uso</option>
                                <option value="success">🟢 Uso bajo (&lt; 50%)</option>
                                <option value="warning">🟡 Uso medio (50% - 80%)</option>
                                <option value="danger">🔴 Uso alto (&gt; 80%)</option>
                            </Form.Select>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Loading State */}
            {cargando && (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="mt-3 text-muted">Cargando información de RNCs...</p>
                </div>
            )}

            {/* List View */}
            {!cargando && (
                <Card className="border-0 shadow-sm">
                    <Card.Body className="p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="border-0 ps-4">Estado</th>
                                        <th className="border-0">Empresa</th>
                                        <th className="border-0">Plan</th>
                                        <th className="border-0">Folios</th>
                                        <th className="border-0">Uso</th>
                                        <th className="border-0 text-end pe-4">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length > 0 ? (
                                        currentItems.map((rnc) => {
                                            const porcentaje = calcularPorcentajeUso(rnc);
                                            const statusColor = getStatusColor(porcentaje);
                                            // Usar dFechaFinPlan (mapeado de dFechaFin)
                                            const estadoPlan = verificarEstadoPlan(rnc.dFechaFinPlan);
                                            
                                            return (
                                                <tr key={rnc.idRepublicaDominicanaFacturacionExistencias}>
                                                    <td className="ps-4 align-middle">
                                                        <Badge bg={rnc.bIsActive ? 'success' : 'danger'} pill>
                                                            {rnc.bIsActive ? 'Activo' : 'Inactivo'}
                                                        </Badge>
                                                    </td>
                                                    <td className="align-middle">
                                                        <div className="fw-semibold">{rnc.vNombre}</div>
                                                        <small className="text-muted d-block">
                                                            <code className="text-dark">{rnc.vRNC}</code>
                                                        </small>
                                                        <small className="text-muted d-block mb-1">
                                                            {rnc.idClienteAkasia} - <Link to={`/clientes/detalle/${rnc.idClienteAkasia}`} className="text-primary text-decoration-none text-uppercase">{rnc.nombreLicenciatario}</Link>
                                                        </small>
                                                        {rnc.licencias && rnc.licencias.length > 0 && (
                                                            <div className="d-flex flex-wrap gap-1">
                                                                {rnc.licencias.slice(0, 5).map((licencia, index) => (
                                                                    <Link 
                                                                        key={index}
                                                                        to={`/licencias/detalle/${licencia}`}
                                                                        className="badge bg-secondary text-decoration-none"
                                                                        style={{ fontSize: '0.7rem' }}
                                                                    >
                                                                        #{licencia}
                                                                    </Link>
                                                                ))}
                                                                {rnc.licencias.length > 5 && (
                                                                    <span className="badge bg-light text-dark" style={{ fontSize: '0.7rem' }}>
                                                                        +{rnc.licencias.length - 5} más
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="align-middle">
                                                        <div className="d-flex align-items-start">
                                                            <div className="flex-grow-1">
                                                                <div className="fw-semibold small d-flex align-items-center">
                                                                    {rnc.planActual || 'Sin plan'}
                                                                    
                                                                </div>
                                                                <small className="text-muted d-block">
                                                                    {rnc.foliosPlan ? `${rnc.foliosPlan} folios` : '-'}
                                                                </small>
                                                                {(rnc.dFechaInicioPlan || rnc.dFechaFinPlan) && (
                                                                    <div className="mt-1">
                                                                        {rnc.dFechaInicioPlan && (
                                                                            <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                                                                                <FontAwesomeIcon icon="calendar-alt" className="me-1" />
                                                                                {formatearFecha(rnc.dFechaInicioPlan)}
                                                                            </small>
                                                                        )}
                                                                        {rnc.dFechaFinPlan && (
                                                                            <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                                                                                <FontAwesomeIcon icon="calendar-check" className="me-1" />
                                                                                {formatearFecha(rnc.dFechaFinPlan)}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                <div><Badge
                                                                    bg={estadoPlan.color}
                                                                    className="ms-2"
                                                                    style={{ fontSize: '0.65rem' }}
                                                                >
                                                                    <FontAwesomeIcon icon={estadoPlan.icono} className="me-1" />
                                                                    {estadoPlan.estado}
                                                                </Badge></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="align-middle">
                                                        <div className="small">
                                                            <strong>{rnc.foliosUsados.toLocaleString()}</strong> / {rnc.dExistencia.toLocaleString()}
                                                        </div>
                                                    </td>
                                                    <td className="align-middle">
                                                        <div className="d-flex align-items-center">
                                                            <div className="progress me-2" style={{ width: '80px', height: '6px' }}>
                                                                <div 
                                                                    className={`progress-bar bg-${statusColor}`}
                                                                    style={{ width: `${porcentaje}%` }}
                                                                />
                                                            </div>
                                                            <small className={`fw-bold text-${statusColor}`}>{porcentaje}%</small>
                                                        </div>
                                                    </td>
                                                    <td className="align-middle pe-4">
                                                        <div className="btn-group btn-group-sm" role="group">
                                                            <Button 
                                                                variant="light" 
                                                                size="sm"
                                                                onClick={() => handleViewDetails(rnc)}
                                                                title="Ver detalles"
                                                            >
                                                                <FontAwesomeIcon icon="eye" />
                                                            </Button>
                                                            <Button 
                                                                variant="light" 
                                                                size="sm"
                                                                onClick={() => handleEditarRNC(rnc)}
                                                                title="Editar"
                                                            >
                                                                <FontAwesomeIcon icon="edit" />
                                                            </Button>
                                                            <Button 
                                                                variant="light" 
                                                                size="sm"
                                                                onClick={() => handleAsignarFolio(rnc)}
                                                                title="Asignar folios"
                                                            >
                                                                <FontAwesomeIcon icon="plus" />
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5">
                                                <div className="mb-3">
                                                    <FontAwesomeIcon icon="inbox" size="3x" className="text-muted" />
                                                </div>
                                                <h5 className="text-muted">No se encontraron RNCs</h5>
                                                <p className="text-muted mb-3">
                                                    {searchTerm ? 'Intenta con otros términos de búsqueda' : 'Comienza agregando tu primer RNC'}
                                                </p>
                                                {!searchTerm && (
                                                    <Button variant="primary" onClick={handleNuevoRNC}>
                                                        <FontAwesomeIcon icon="plus" className="me-2" />
                                                        Agregar RNC
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Paginación */}
                        {filteredRNCs.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center p-3 border-top">
                                <div className="text-muted small">
                                    Mostrando {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, filteredRNCs.length)} de {filteredRNCs.length} registros
                                </div>
                                <Pagination className="mb-0">
                                    <Pagination.First 
                                        onClick={() => handlePageChange(1)} 
                                        disabled={currentPage === 1}
                                    />
                                    <Pagination.Prev 
                                        onClick={() => handlePageChange(currentPage - 1)} 
                                        disabled={currentPage === 1}
                                    />
                                    
                                    {getPageNumbers().map((number, index) => (
                                        number === '...' ? (
                                            <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                                        ) : (
                                            <Pagination.Item
                                                key={number}
                                                active={number === currentPage}
                                                onClick={() => handlePageChange(number)}
                                            >
                                                {number}
                                            </Pagination.Item>
                                        )
                                    ))}
                                    
                                    <Pagination.Next 
                                        onClick={() => handlePageChange(currentPage + 1)} 
                                        disabled={currentPage === totalPages}
                                    />
                                    <Pagination.Last 
                                        onClick={() => handlePageChange(totalPages)} 
                                        disabled={currentPage === totalPages}
                                    />
                                </Pagination>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            )}

            {/* Panel lateral de detalles, edición y nuevo RNC */}
            <Offcanvas show={showDetails} onHide={handleCloseDetails} placement="end" style={{ width: '500px' }}>
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="fw-bold">
                        <FontAwesomeIcon icon="building" className="me-2 text-primary" />
                        {activeTab === 'nuevo' ? 'Nuevo RNC' : activeTab === 'asignar' ? 'Asignar Plan' : 'Detalles del RNC'}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                        <Nav variant="pills" className="mb-3">
                            {activeTab === 'nuevo' || activeTab === 'asignar' ? (
                               <></>
                            ) : (
                                <>
                                    <Nav.Item>
                                        <Nav.Link eventKey="general" className="small">
                                            <FontAwesomeIcon icon="info-circle" className="me-1" />
                                            General
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="editar" className="small">
                                            <FontAwesomeIcon icon="edit" className="me-1" />
                                            Editar
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="folios" className="small">
                                            <FontAwesomeIcon icon="receipt" className="me-1" />
                                            Folios
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="actividad" className="small">
                                            <FontAwesomeIcon icon="clock" className="me-1" />
                                            Actividad
                                        </Nav.Link>
                                    </Nav.Item>
                                </>
                            )}
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey="nuevo">
                                <TabNuevoRNC
                                    onSuccess={handleSuccessNuevoRNC}
                                    onCancel={handleCancelarNuevo}
                                />
                            </Tab.Pane>

                            <Tab.Pane eventKey="asignar">
                                <TabAsignarPlan
                                    idRNC={idRNCSeleccionado}
                                    vNombre={rncSeleccionado?.vNombre}
                                    vRNC={rncSeleccionado?.vRNC}
                                    onSuccess={handleSuccessAsignarFolio}
                                    onCancel={handleCloseDetails}
                                />
                            </Tab.Pane>

                            <Tab.Pane eventKey="general">
                                <TabGeneral
                                    rnc={rncSeleccionado}
                                    onEdit={() => setActiveTab('editar')}
                                    onAsignarFolios={handleAsignarFolio}
                                />
                            </Tab.Pane>

                            <Tab.Pane eventKey="editar">
                                <TabEditar
                                    rnc={rncSeleccionado}
                                    guardando={guardando}
                                    onSave={GuardarRNC}
                                    onCancel={handleCancelarEdicion}
                                    onGenerarCadena={ObtenerCadenaRandom}
                                />
                            </Tab.Pane>

                            <Tab.Pane eventKey="folios">
                                <TabFolios
                                    rnc={rncSeleccionado}
                                    onAsignarMas={handleAsignarFolio}
                                    calcularPorcentaje={calcularPorcentajeUso}
                                    getStatusColor={getStatusColor}
                                />
                            </Tab.Pane>

                            <Tab.Pane eventKey="actividad">
                                <TabActividad rnc={rncSeleccionado} />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Offcanvas.Body>
            </Offcanvas>

            {/* Modal de Administración de Planes */}
            <ModalAdministrarPlanes
                show={showModalPlanes}
                onHide={() => setShowModalPlanes(false)}
                onSuccess={() => {
                    // Refrescar planes si es necesario
                }}
            />

            <style jsx="true">{`
                .stat-card {
                    position: relative;
                    overflow: hidden;
                    border-radius: 12px !important;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                
                .stat-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 4px;
                    background: linear-gradient(90deg, var(--card-color-start), var(--card-color-end));
                    transition: height 0.3s ease;
                }
                
                .stat-card-primary {
                    --card-color-start: #0d6efd;
                    --card-color-end: #0a58ca;
                }
                
                .stat-card-success {
                    --card-color-start: #198754;
                    --card-color-end: #146c43;
                }
                
                .stat-card-info {
                    --card-color-start: #0dcaf0;
                    --card-color-end: #0aa2c0;
                }
                
                .stat-card-warning {
                    --card-color-start: #ffc107;
                    --card-color-end: #cc9a06;
                }
                
                .hover-shadow {
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                
                .hover-shadow:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 12px 24px rgba(0,0,0,0.15) !important;
                }
                
                .hover-shadow:hover::before {
                    height: 6px;
                }
                
                .transition-all {
                    transition: all 0.3s ease;
                }
                
                .icon-circle {
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                }
                
                .hover-shadow:hover .icon-circle {
                    transform: scale(1.1);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
                
                .timeline-icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.875rem;
                    flex-shrink: 0;
                }
            `}</style>
        </>
    );
};

export default PlanesFacturacionRepublicaDominicana;
